import type { Locale, TextLinkGroup } from '@seek/cmsu-cms-connect';
import { toUrl } from '../../utils';
import type { NestedLink } from './types';
import type { Language } from '@seek/melways-sites';
import { checkSkipDefaultLocale } from '../../utils/checkSkipDefaultLocale';
import { adapter } from '@seek/tealium-adapter';

/*
  Convert the array of links of type TextLinkGroup
  to a simplified array of NestedLink objects
  @param linkArray - array of links of type TextLinkGroup
  @param language - the current language eg., 'en'
  @param locale - the current site locale eg., 'en_AU'
*/
export const convertLinks = (
  linkArray: TextLinkGroup[],
  language: Language,
  locale: Locale,
): NestedLink[] => {
  const arr = linkArray.map((item) => {
    const { link, subLinks } = item;
    if (checkSkipDefaultLocale(link!.skipDefaultLocale, link!.locale, locale)) {
      return null;
    }

    return {
      text: link?.text || '',
      url: toUrl(link?.link?.to as any, language),
      subLinks:
        subLinks
          .map((s) => {
            if (checkSkipDefaultLocale(s.skipDefaultLocale, s.locale, locale)) {
              return null;
            }
            return {
              text: s.text || '',
              url: toUrl(s.link?.to as any),
            };
          })
          .filter(Boolean) || [],
    };
  });

  return arr as NestedLink[];
};

export const tealium = adapter();

export const trackLink = (
  trackingEvent: string,
  trackingAttributes: Record<string, string>,
) => {
  tealium.link(trackingEvent, trackingAttributes);
};
